// extracted by mini-css-extract-plugin
export default {"container":"UpsellBulletPoints_container__wk0vo","checkIcon":"UpsellBulletPoints_checkIcon__+HqdI"};